import { fazendaService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const fazendaAction = {
    copyFazenda,
    getFazenda,
    getFazendaSelect,
    getFazendaById,
    getFazendasByIdUsuario,
    onChangeProps,
    editFazendaInfo,
    importAcasalamentosFazenda,
    importAnimaisDescartadosFazenda,
    importCcsFazenda,
    importCulturaFazenda,
    importFazenda,
    importInseminacoesFazenda,
    importProducaoFazenda,
    importPartosFazenda,
    importPesagensFazenda,
    importSecagensFazenda,
    importSaudeUberesFazenda,
    importSaudeAnimalFazenda,
    createFazenda,
    deleteFazendaById,
    getFormasIngressoSelect,
    clear
};
function getFazenda(showWaiting, page = 1, limit = 10, term = "") {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }

        let apiEndpoint = `fazendas?page=${page}&limit=${limit}`;
        if (term) {
            apiEndpoint += `&term=${encodeURIComponent(term)}`;
        }

        fazendaService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    //response.data.Items.unshift({ id: '0', nome: ' SELECIONE ...' });
                    dispatch(changeFazendasList(response.data.Items, response.data.TotalItems));
                    //dispatch(setTotalItems(response.data.TotalItems)); // Guardar o total no estado global
                    //  console.log("response.data", response.data)
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function getFazendasByIdUsuario(showWaiting, id) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }

        let apiEndpoint = `fazendas/usuario/${id}`;

        fazendaService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeFazendasList(response.data.Items, response.data.TotalItems));
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function getFazendaSelect(showWaiting) {
    return (dispatch) => {
        if (showWaiting) {
            alerts.waiting();
        }

        const apiEndpoint = 'fazendas/select'
        fazendaService
            .get(apiEndpoint)
            .then((response) => {
                if (response?.data) {
                    dispatch(changeFazendasList(response?.data))
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    }
}
function createFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clear());
                    alerts.success(ret.message, '/fazendas');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function importFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    if (ret.retorno) {
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function importCcsFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/ccs/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importCulturaFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/cultura/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function copyFazenda(payload) {
    return dispatch => {
        let apiEndpoint = 'fazendas/copy';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importAcasalamentosFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/acasalamentos/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function importProducaoFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/producao/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importAnimaisDescartadosFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/animais_descartados/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importSecagensFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/secagens/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importPesagensFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/pesagens/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importSaudeUberesFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/saudeUberes/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importSaudeAnimalFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/importar/saude';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas');
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas');
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function importPartosFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/partos/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function importInseminacoesFazenda(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Chamadas/import/inseminacoes/';
        fazendaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/fazendas'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/fazendas'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            })
    }
}
function getFazendaById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/' + id;
        fazendaService.get(apiEndpoint)
            .then((response) => {
                dispatch(editFazendasDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function editFazendaInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/' + id;
        fazendaService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    dispatch(clear());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/fazendas');
                } else {
                    alerts.warning(response.data.Message);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function deleteFazendaById(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/delete/' + id
        fazendaService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    dispatch(clear());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/fazendas');
                    dispatch(fazendaAction.getFazenda());
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
}
export function changeFazendasList(fazenda, totalItems) {
    return {
        type: "FETECHED_ALL_FAZENDA",
        fazenda: fazenda,
        totalItems: totalItems
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editFazendasDetails(fazenda) {

    return {
        type: "FAZENDA_DETAIL",
        id: fazenda.id,
        nome: fazenda.nome,
        nome_proprietario: fazenda.nome_proprietario,
        pessoa: fazenda.pessoa,
        codigo: fazenda.codigo,
        data_inicio_cobranca: fazenda.data_inicio_cobranca,
        data_treinamento: fazenda.data_treinamento,
        dias_secagem: fazenda.dias_secagem,
        dias_parto: fazenda.dias_parto,
        dias_bst: fazenda.dias_bst,
        dias_pre_parto_novilha: fazenda.dias_pre_parto_novilha,
        dias_pre_parto: fazenda.dias_pre_parto,
        limite_peso_cio: fazenda.limite_peso_cio,
        limite_idade_cio: fazenda.limite_idade_cio,
        pev: fazenda.pev,
        listaUsuarios: fazenda.listaUsuarios,
        usuarios_financeiro: fazenda.usuarios_financeiro,
        gera_cobranca: fazenda.gera_cobranca,
        modulo_financeiro: fazenda.modulo_financeiro,
        modulo_zootecnico: fazenda.modulo_zootecnico,
        id_empresa: fazenda.id_empresa,
        empresa: fazenda.empresa,
        data_cadastro: fazenda.data_cadastro,
        usuario_cadastro: fazenda.usuario_cadastro,
        data_exclusao: fazenda.data_exclusao,
        usuario_exclusao: fazenda.usuario_exclusao,
        id_motivo_desistencia: fazenda.id_motivo_desistencia,
        endereco: fazenda.endereco,
        id_cidade: fazenda.id_cidade,
        id_estado: fazenda.id_estado,
        data_importacao: fazenda.data_importacao,
        data_treinamento_financeiro: fazenda.data_treinamento_financeiro,
        gera_cobranca_financeiro: fazenda.gera_cobranca_financeiro,
        data_inicio_cobranca_financeiro: fazenda.data_inicio_cobranca_financeiro,
        id_forma_ingresso: fazenda.id_forma_ingresso
    }
}
export function updatedUserInfo() {
    return {
        type: "FAZENDA_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "FAZENDA_CREATED_SUCCESSFULLY"
    }
}
export function deleteFazendasDetails() {
    return {
        type: "DELETED_FAZENDA_DETAILS"
    }
}
export function clear() {
    return {
        type: "FAZENDA_CLEAR"
    };
}
function getFormasIngressoSelect(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/formasIngresso/select';
        fazendaService.get(apiEndpoint)
            .then((response) => {
                if (response && response.data) {
                    response.data.unshift({ Value: '', Text: ' SELECIONE ...' });
                    dispatch({
                        type: 'FETCHED_ALL_FORMA_INGRESSO',
                        formasIngresso: response.data
                    });
                }
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                if (showWaiting) {
                    alerts.clean();
                }
            })
    };
}